import {
  CuratedColumnSymbology,
  InterpolationTypes,
  SymbologyScales,
  SymbologyTypes,
} from 'uf/symbology';

const symbologies: Record<string, Record<string, CuratedColumnSymbology[]>> = {
  '/public/dataset/cal_fire_cal_fire_direct_protection_areas': {
    dpa_agency: [
      {
        display_hints: {
          distribution: null,
          interpolation: InterpolationTypes.CATEGORICAL,
          scale: SymbologyScales.CATEGORICAL,
          theme: 'custom',
        },
        paint: {
          'fill-color': {
            default: '#7f7f7f',
            property: 'dpa_agency',
            stops: [
              {
                color: '#c45100',
                value: 'BLM',
              },
              {
                color: '#fcdc00',
                value: 'CDF',
              },
              {
                color: '#fe9200',
                value: 'DOD',
              },
              {
                color: '#dbdf00',
                value: 'LOCAL',
              },
              {
                color: '#e27300',
                value: 'NPS',
              },
              {
                color: '#d33115',
                value: 'UFW',
              },
              {
                color: '#f44e3b',
                value: 'USF',
              },
            ],
            type: 'categorical',
          },
          'fill-opacity': 0.5,
        },
        type: SymbologyTypes.FILL,
      },
      {
        display_hints: {
          distribution: null,
          interpolation: InterpolationTypes.CATEGORICAL,
          scale: SymbologyScales.CATEGORICAL,
          theme: 'custom',
        },
        paint: {
          'line-color': '#999999',
          'line-opacity': 0.5,
          'line-width': 1,
        },
        type: SymbologyTypes.LINE,
      },
    ],
  },
};

export default symbologies;
